/* eslint-disable @typescript-eslint/no-explicit-any */
import contentfulClient from "shared/services/contentful";

export const fetchTranslations = async (
  locale: string,
  resourceSetName: string
) => {
  try {
    const response = await contentfulClient.getEntries({
      content_type: "resourceSet",
      "fields.slug": resourceSetName.toLocaleLowerCase(),
      include: 2,
      locale,
    });

    if (!response.items || response.items.length === 0) {
      throw new Error(`Resource Set '${resourceSetName}' not found or empty`);
    }

    const resourceSet = response.items[0];
    const resourceIds = Array.isArray(resourceSet.fields.resources)
      ? resourceSet.fields.resources.map((r: any) => r.sys.id)
      : [];

    if (resourceIds.length === 0) {
      console.warn(`No resources found in Resource Set: '${resourceSetName}'`);
      return {};
    }

    const translations: Record<string, string> = {};
    response.includes?.Entry?.forEach((entry: any) => {
      if (resourceIds.includes(entry.sys.id)) {
        translations[entry.fields.key] = entry.fields.value;
      }
    });

    return translations;
  } catch (error) {
    console.error("Error fetching translations:", error);
    return {};
  }
};

export const getResourceSetId = async (resourceSetName: string) => {
  const response = await contentfulClient.getEntries({
    content_type: "resourceSet",
    "fields.name": resourceSetName,
  });

  if (response.items.length === 0) {
    throw new Error(`Resource Set '${resourceSetName}' not found`);
  }

  return response.items[0].sys.id;
};
